__turbopack_context__.v({
  "className": "bebas_neue_13355b04-module__C-q75W__className",
  "variable": "bebas_neue_13355b04-module__C-q75W__variable",
});
